/**
 * The machine `code` of an API refusal, read from the response body only. Axios's own
 * top-level `code` (`ERR_BAD_REQUEST`) is a transport fact, never the server's reason.
 */
export function extractBackendCode(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') return undefined;
  const response = (error as { response?: unknown }).response;
  if (!response || typeof response !== 'object') return undefined;
  const data = (response as { data?: unknown }).data;
  if (!data || typeof data !== 'object') return undefined;
  const code = (data as { code?: unknown }).code;
  return typeof code === 'string' ? code : undefined;
}
